import store from 'pages/store';
import SocketClient from 'pages/views/devices/socketClient';
import { STATUS, CFD_MESSAGES } from 'pages/views/devices/socketClient/types';
import { onVisibilityChange } from 'pages/views/devices/utils/focus-handler';
import {
  setHubSmartState,
  removeHubSmartConnection,
  renameLocalStorageKeys,
  removeDisplayMsrp,
  getChannelName,
  getHubSmartState,
} from 'pages/views/devices/utils/storage';
import { updateConnectionStatus } from 'root/apps/pages/store/reducers/hub';

export const registerHubSmartEvents = () => {
  const state = getHubSmartState() || store.getState().hub;

  if (
    state.connection.hub === STATUS.CONNECTED ||
    state.connection.browserCFD === STATUS.CONNECTED
  ) {
    setHubSmartState(state);
  }
};

export const removeHubSmartEvents = () => {
  removeHubSmartConnection();
  if (store.getState().hub.connection.ably !== SocketClient.status) {
    store.dispatch(updateConnectionStatus(SocketClient.status));
  }
};

export const initHub = () => {
  removeDisplayMsrp();
  renameLocalStorageKeys();
  const channelName = getChannelName();

  SocketClient.init(channelName);

  onVisibilityChange((isVisible: boolean) => {
    const formNamesBlacklist = ['close_register'];
    const isDenyListed = formNamesBlacklist.some(formName => {
      return window.location.href.includes(formName);
    });
    if (SocketClient.status === STATUS.CONNECTED) {
      if (isVisible && window.location.pathname === '/register.php' && !isDenyListed) {
        SocketClient.send(CFD_MESSAGES.SHOW_SALE);
      } else {
        SocketClient.send(CFD_MESSAGES.HIDE_SALE);
      }
    } else if (isVisible && SocketClient.status === STATUS.DISCONNECTED) {
      SocketClient.connect();
    }
  });

  // Handle the case where the register is closed.
  window.merchantos.asyncSubscribe.subscribeToFormCall('closing_counts', () => {
    if (SocketClient?.status === STATUS.CONNECTED) {
      SocketClient.send(CFD_MESSAGES.HIDE_SALE);
    }
  });
};
